<template>
  <!-- 证书 -->
  <div>
    <div class="top_tit">
      <div class="line"></div>
      <p>{{ ficate.Name }}</p>
    </div>
    <div class="bottom_content">
      <div v-if="ficate.Deliveries.length > '0'">
        <img
          v-for="e in ficate.Deliveries"
          :key="e.ModuleInstanceId"
          alt=""
          :src="api.FileHost + e.DeliveryUrl"
        />
      </div>

      <!-- 暂无文本 -->
      <!-- <van-empty v-else description="暂无证书" image-size="40" /> -->
    </div>
    <!-- <div v-else class="bottom_content">
      <van-empty description="暂无结业证书" image-size="40" />
    </div> -->
  </div>
</template>

<script>
  import api from '@/api'
  export default {
    props: {
      // eslint-disable-next-line vue/require-default-prop
      ficate: {
        type: Object,
      },
    },
    setup(props) {
      return {
        api,
      }
    },
  }
</script>

<style lang="scss" scoped>
  .bottom_content {
    position: relative;
    padding: 15px;
    img {
      width: 100%;
    }
  }
</style>
